import React from 'react'
import ReactDOM from 'react-dom'
import { PageBase } from 'frontend/common-imports'
import Schedule from 'frontend/schedule/schedule'

export default class SchedulePage extends PageBase {
  static render () {
    ReactDOM.render(
      React.createElement(Schedule),
      document.getElementById('schedule_react')
    )
  }
}

SchedulePage.init()
